interface AuthLayoutProps {
  children: React.ReactNode
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-cream via-mist to-sky/20 p-4">
      <div className="w-full max-w-md">{children}</div>
    </div>
  )
}
